export default __webpack_public_path__ + "static/media/khalifa-port-free-zone-trade.21d01ba9.png";